export enum DocumentDetailsPaymentStatus {
    Free,
    Paid,
    Unpaid,
}
